import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса инвентаризации native-контракта 1С v1 (срез B4b) и справочника
 * складов базы. Литерал `/api/` законен только здесь. Склады — ручка
 * `Supplies_ResourceWarehouses`: отдельного справочника складов у
 * инвентаризации в контракте нет (запрос интегратору в evidence UB1d).
 */
const base = (resourceId: string) => `/api/onec/v1/resources/${ridSegment(resourceId)}`

export const ONEC_INVENTORY_URLS = {
  scan: (resourceId: string) => `${base(resourceId)}/inventory/scan`,
  product: (resourceId: string) => `${base(resourceId)}/inventory/product`,
  session: (resourceId: string) => `${base(resourceId)}/inventory/session`,
} as const
